import { useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import $, { data } from "jquery";
// import DataTable from "datatables.net";
import { MainArea, MainAreaHeader, MainAreaBody } from "../../layout/MainArea";
import { getDataTableDom, requestToServer } from "../../utils/appUtils";
import TableDT from "../../UI/TableDT";
import { TabView, TabPanel } from 'primereact/tabview';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { GetInfoMC } from "../../../api";

const ROUTE_URL = "/get_conn_mc";

function MsData(props) {
    const token = localStorage.getItem('token')
    clearInterval(window.timer)
    const [serverData, setServerData] = useState(null);
    const { showErrorPage, messageBox } = useOutletContext();
    const [currentPageOne, setCurrentPageOne] = useState(1);
    const [activeIndex, setActiveIndex] = useState(0)
    const [arrTableOne, setArrTableOne] = useState([])
    const navigate = useNavigate();

    const handleAddRow = () => {
        navigate("./create");
    };

    useEffect(() => {
        let offset = (currentPageOne - 1) * 10;
        GetInfoMC(token, ROUTE_URL, activeIndex + 1, offset, 10).then((e) => {
      
            setArrTableOne(e.data.data)
        })
    }, [currentPageOne, activeIndex])

    // const handleAfterDTCreate = ({ DOM, Api }) => {
    //     dtTable1.Api = Api;
    //     $(DOM).on('click', 'tbody button[name="btnDelete"]', function (e) {
    //         e.preventDefault();
    //         let data = dtTable1.Api.row($(this).parents('tr')).data();
    //         let urlDelete = ROUTE_URL + "/" + data.id;
    //         messageBox({
    //             show: true, message: `Вы действительно хотите удалить "${data.name}"?`, mbOk: (e) => {
    //                 e.preventDefault();
    //                 messageBox({ show: false, mbOk: null });
    //                 requestToServer(urlDelete, { method: 'DELETE' }, () => { dtTable1.Api.ajax.reload(); }, (error) => { alert(JSON.stringify(error)); }, false);
    //             }
    //         });
    //     });
    //     $(DOM).on('click', 'tbody a[name="btnShowEdit"]', function (e) {
    //         e.preventDefault();
    //         let data = dtTable1.Api.row($(this).parents('tr')).data();
    //         let urlStr = "./" + data.id;
    //         navigate(urlStr);
    //     });

    // }

    useEffect(() => {
        requestToServer(ROUTE_URL + "?crud", { method: 'GET' }, setServerData, showErrorPage, true);
    }, []);




    if (serverData === null)
        return <MainArea loading />;

    return (
        <MainArea>
            <MainAreaHeader caption="Данные МС" />
            <MainAreaBody containerClass="">
                {/* {
                    <div><button type="button" className="btn btn-primary btn-sm btn-our" onClick={handleAddRow}>Добавить</button></div>
                } */}
                {/* <TableDT getOptions={() => dtTable.getTableOptions(serverData.crud)} afterCreate={handleAfterDTCreate} /> */}

                <div className="container-fluid px-3 py-1 dashboard">
                    <div className="row g-3">
                    <TabView activeIndex={activeIndex} onTabChange={(e) => {setActiveIndex(e.index)
                        setCurrentPageOne(1)
                    }}> 
                        <TabPanel header="Комплект 1">
                            <div className="cont-table">
                            <DataTable removableSort emptyMessage="Нет данных" value={arrTableOne} tableStyle={{ minWidth: '50rem' }}>
                                {/* <Column field="code" sortable header="Временная метка"></Column> */}
                                <Column field="ps_number" sortable header="Номер МС (ЛСН) в системе"></Column>
                                <Column field="ip_address" sortable header="IP адрес МС в служебном канале ЛСН"></Column>
                                <Column field="rf_power" sortable header="Текущее значение мощности"></Column>
                                <Column field="tracking_duration" sortable header="Время захвата сигнала МС (ЛСН) на СЧ ПУ ЛСН"></Column>
                            </DataTable>
                            <div className="paginator">
                                <button
                                disabled={currentPageOne <= 1}
                                className="btn"
                                onClick={() => {
                                    setCurrentPageOne(currentPageOne - 1);
                                }}
                                >
                                {"<"}
                                </button>
                                <div className="text">{currentPageOne}</div>
                                <button
                                disabled={arrTableOne?.length < 10}
                                className="btn"
                                onClick={() => {
                                    setCurrentPageOne(currentPageOne + 1);
                                }}
                                >
                                {">"}
                                </button>
                                    </div>
                            </div>
                        </TabPanel>
                        <TabPanel header="Комплект 2">
                            <div className="cont-table">
                            <DataTable removableSort emptyMessage="Нет данных" value={arrTableOne} tableStyle={{ minWidth: '50rem' }}>
                                {/* <Column field="code" sortable header="Временная метка"></Column> */}
                                <Column field="ps_number" sortable header="Номер МС (ЛСН) в системе"></Column>
                                <Column field="ip_address" sortable header="IP адрес МС в служебном канале ЛСН"></Column>
                                <Column field="rf_power" sortable header="Текущее значение мощности"></Column>
                                <Column field="tracking_duration" sortable header="Время захвата сигнала МС (ЛСН) на СЧ ПУ ЛСН"></Column>
                            </DataTable>
                            <div className="paginator">
                                <button
                                disabled={currentPageOne <= 1}
                                className="btn"
                                onClick={() => {
                                    setCurrentPageOne(currentPageOne - 1);
                                }}
                                >
                                {"<"}
                                </button>
                                <div className="text">{currentPageOne}</div>
                                <button
                                disabled={arrTableOne?.length < 10}
                                className="btn"
                                onClick={() => {
                                    setCurrentPageOne(currentPageOne + 1);
                                }}
                                >
                                {">"}
                                </button>
                                    </div>
                            </div>
                        </TabPanel>
                        <TabPanel header="Комплект 3">
                            <div className="cont-table">
                            <DataTable removableSort emptyMessage="Нет данных" value={arrTableOne} tableStyle={{ minWidth: '50rem' }}>
                                {/* <Column field="code" sortable header="Временная метка"></Column> */}
                                <Column field="ps_number" sortable header="Номер МС (ЛСН) в системе"></Column>
                                <Column field="ip_address" sortable header="IP адрес МС в служебном канале ЛСН"></Column>
                                <Column field="rf_power" sortable header="Текущее значение мощности"></Column>
                                <Column field="tracking_duration" sortable header="Время захвата сигнала МС (ЛСН) на СЧ ПУ ЛСН"></Column>
                            </DataTable>
                            <div className="paginator">
                                <button
                                disabled={currentPageOne <= 1}
                                className="btn"
                                onClick={() => {
                                    setCurrentPageOne(currentPageOne - 1);
                                }}
                                >
                                {"<"}
                                </button>
                                <div className="text">{currentPageOne}</div>
                                <button
                                disabled={arrTableOne?.length < 10}
                                className="btn"
                                onClick={() => {
                                    setCurrentPageOne(currentPageOne + 1);
                                }}
                                >
                                {">"}
                                </button>
                                    </div>
                            </div>
                        </TabPanel>
                        <TabPanel header="Комплект 4">
                            <div className="cont-table">
                            <DataTable removableSort emptyMessage="Нет данных" value={arrTableOne} tableStyle={{ minWidth: '50rem' }}>
                                {/* <Column field="code" sortable header="Временная метка"></Column> */}
                                <Column field="ps_number" sortable header="Номер МС (ЛСН) в системе"></Column>
                                <Column field="ip_address" sortable header="IP адрес МС в служебном канале ЛСН"></Column>
                                <Column field="rf_power" sortable header="Текущее значение мощности"></Column>
                                <Column field="tracking_duration" sortable header="Время захвата сигнала МС (ЛСН) на СЧ ПУ ЛСН"></Column>
                            </DataTable>
                            <div className="paginator">
                                <button
                                disabled={currentPageOne <= 1}
                                className="btn"
                                onClick={() => {
                                    setCurrentPageOne(currentPageOne - 1);
                                }}
                                >
                                {"<"}
                                </button>
                                <div className="text">{currentPageOne}</div>
                                <button
                                disabled={arrTableOne?.length < 10}
                                className="btn"
                                onClick={() => {
                                    setCurrentPageOne(currentPageOne + 1);
                                }}
                                >
                                {">"}
                                </button>
                                    </div>
                            </div>
                        </TabPanel>
                    </TabView>
                        </div>
                </div>

            </MainAreaBody>
        </MainArea>
    );
}

// let dtTable1 = {
//     Api: null,
//     getTableOptions: (crud) => {
//         const dtOptions = {
//             ordering: true, lengthChange: true, filter: true, paging: false, info: false, processing: true,
//             order: [[1, "asc"]],
//             ajax: { type: "GET", url: ROUTE_URL + "?kks_psats_info&1" },
//             dom: getDataTableDom("lfip", 2, 1),
//             columns: [
//                 { data: "0", title: "Временная метка", render: DataTable.render.date(), },
//                 { data: "ps_number", title: "Номер МС (ЛСН) в системе", render: DataTable.render.number(), },
//                 { data: "ip_address", title: "IP адрес МС в служебном канале ЛСН", render: DataTable.render.text(), },
//                 { data: "coords.latitude", title: "Широта", render: DataTable.render.text(), },
//                 { data: "coords.longitude", title: "Долгота", render: DataTable.render.text(), },
//                 { data: "coords.altitude", title: "Высота", render: DataTable.render.text(), },
//                 { data: "rf_power", title: "Текущее значение мощности", render: DataTable.render.number(), },
//                 { data: "tracking_duration", title: "Время захвата сигнала МС (ЛСН) на СЧ ПУ ЛСН", render: DataTable.render.number(), },
//             ],
//         };
//         if ((crud & 1) === 0) {
//             dtOptions.order = [[0, "asc"]];
//             dtOptions.columns.splice(0, 1);
//             dtOptions.dom = getDataTableDom("lfip", 1, 1);
//         }

//         return dtOptions;
//     }
// };

// let dtTable2 = {
//     Api: null,
//     getTableOptions: (crud) => {
//         const dtOptions = {
//             ordering: true, lengthChange: true, filter: true, paging: true, info: true, processing: true,
//             order: [[1, "asc"]],
//             ajax: { type: "GET", url: ROUTE_URL + "?kks_psats_info&2" },
//             dom: getDataTableDom("lfip", 2, 1),
//             columns: [
//                 { data: "timestamp", title: "Временная метка", render: DataTable.render.date(), },
//                 { data: "ps_number", title: "Номер МС (ЛСН) в системе", render: DataTable.render.number(), },
//                 { data: "ip_address", title: "IP адрес МС в служебном канале ЛСН", render: DataTable.render.text(), },
//                 { data: "coords.latitude", title: "Широта", render: DataTable.render.text(), },
//                 { data: "coords.longitude", title: "Долгота", render: DataTable.render.text(), },
//                 { data: "coords.altitude", title: "Высота", render: DataTable.render.text(), },
//                 { data: "rf_power", title: "Текущее значение мощности", render: DataTable.render.number(), },
//                 { data: "tracking_duration", title: "Время захвата сигнала МС (ЛСН) на СЧ ПУ ЛСН", render: DataTable.render.number(), },
//             ],
//         };
//         if ((crud & 1) === 0) {
//             dtOptions.order = [[0, "asc"]];
//             dtOptions.columns.splice(0, 1);
//             dtOptions.dom = getDataTableDom("lfip", 1, 1);
//         }

//         return dtOptions;
//     }
// };

// let dtTable3 = {
//     Api: null,
//     getTableOptions: (crud) => {
//         const dtOptions = {
//             ordering: true, lengthChange: true, filter: true, paging: true, info: true, processing: true,
//             order: [[1, "asc"]],
//             ajax: { type: "GET", url: ROUTE_URL + "?kks_psats_info&3" },
//             dom: getDataTableDom("lfip", 2, 1),
//             columns: [
//                 { data: "timestamp", title: "Временная метка", render: DataTable.render.date(), },
//                 { data: "ps_number", title: "Номер МС (ЛСН) в системе", render: DataTable.render.number(), },
//                 { data: "ip_address", title: "IP адрес МС в служебном канале ЛСН", render: DataTable.render.text(), },
//                 { data: "coords.latitude", title: "Широта", render: DataTable.render.text(), },
//                 { data: "coords.longitude", title: "Долгота", render: DataTable.render.text(), },
//                 { data: "coords.altitude", title: "Высота", render: DataTable.render.text(), },
//                 { data: "rf_power", title: "Текущее значение мощности", render: DataTable.render.number(), },
//                 { data: "tracking_duration", title: "Время захвата сигнала МС (ЛСН) на СЧ ПУ ЛСН", render: DataTable.render.number(), },
//             ],
//         };
//         if ((crud & 1) === 0) {
//             dtOptions.order = [[0, "asc"]];
//             dtOptions.columns.splice(0, 1);
//             dtOptions.dom = getDataTableDom("lfip", 1, 1);
//         }

//         return dtOptions;
//     }
// };

// let dtTable4 = {
//     Api: null,
//     getTableOptions: (crud) => {
//         const dtOptions = {
//             ordering: true, lengthChange: true, filter: true, paging: true, info: true, processing: true,
//             order: [[1, "asc"]],
//             ajax: { type: "GET", url: ROUTE_URL + "?kks_psats_info&4" },
//             dom: getDataTableDom("lfip", 2, 1),
//             columns: [
//                 { data: "timestamp", title: "Временная метка", render: DataTable.render.date(), },
//                 { data: "ps_number", title: "Номер МС (ЛСН) в системе", render: DataTable.render.number(), },
//                 { data: "ip_address", title: "IP адрес МС в служебном канале ЛСН", render: DataTable.render.text(), },
//                 { data: "coords.latitude", title: "Широта", render: DataTable.render.text(), },
//                 { data: "coords.longitude", title: "Долгота", render: DataTable.render.text(), },
//                 { data: "coords.altitude", title: "Высота", render: DataTable.render.text(), },
//                 { data: "rf_power", title: "Текущее значение мощности", render: DataTable.render.number(), },
//                 { data: "tracking_duration", title: "Время захвата сигнала МС (ЛСН) на СЧ ПУ ЛСН", render: DataTable.render.number(), },
//             ],
//         };
//         if ((crud & 1) === 0) {
//             dtOptions.order = [[0, "asc"]];
//             dtOptions.columns.splice(0, 1);
//             dtOptions.dom = getDataTableDom("lfip", 1, 1);
//         }

//         return dtOptions;
//     }
// };

export default MsData;
